(() => {
  'use strict';
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = (selector) => root.querySelector(selector);
    const form = $('form');
    const submit = $('[data-submit]');
    const payment = $('[data-payment]');
    const storageKey = 'flashlabel-vn-qr-submission-v1';
    const noticeKey = 'flashlabel-vn-qr-payment-notice-v1';
    const noticePanel = $('[data-payment-notice]');
    const noticeForm = $('[data-payment-notice-form]');
    let savedNotice;
    try { savedNotice = JSON.parse(sessionStorage.getItem(noticeKey)); } catch (_) { /* optional */ }
    let cart;
    let prepared = false;
    const money = (amount) => new Intl.NumberFormat('vi-VN', {style: 'currency', currency: 'VND', maximumFractionDigits: 0}).format(amount / 100);
    const normalizePhone = (value) => value.replace(/[ ()-]/g, '');
    const validateCart = (value) => {
      if (!value || value.currency !== 'VND') throw new Error('Giỏ hàng cần sử dụng VND. Vui lòng quay lại giỏ hàng và chọn thị trường Việt Nam.');
      if (!value.items || !value.items.length) throw new Error('Giỏ hàng đang trống. Vui lòng thêm sản phẩm trước khi gửi thông tin.');
      if (!Number.isSafeInteger(value.total_price) || value.total_price <= 0) throw new Error('Không xác định được số tiền thanh toán. Vui lòng liên hệ FlashLabel.');
      if (value.items.some((item) => item.selling_plan_allocation)) throw new Error('Vui lòng liên hệ FlashLabel để mua sản phẩm đăng ký định kỳ.');
      return value;
    };
    const loadCart = async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(root.dataset.cartUrl, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
        if (!response.ok) throw new Error('Không tải được giỏ hàng. Vui lòng tải lại trang và thử lại.');
        return validateCart(await response.json());
      } finally { clearTimeout(timeout); }
    };
    const renderCart = (value) => {
      const container = $('[data-cart-items]');
      container.replaceChildren();
      value.items.forEach((item) => {
        const row = document.createElement('div'); row.className = 'flqr__item';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image; image.alt = item.product_title || item.title;
          image.width = 64; image.height = 64; image.loading = 'lazy'; row.append(image);
        }
        const detail = document.createElement('div');
        const name = document.createElement('strong'); name.textContent = item.product_title || item.title; detail.append(name);
        [item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '', 'Số lượng: ' + item.quantity, money(item.final_line_price)].filter(Boolean).forEach((text) => {
          const line = document.createElement('span'); line.textContent = text; detail.append(line);
        });
        row.append(detail); container.append(row);
      });
      $('[data-subtotal]').textContent = money(value.total_price);
      $('[data-total]').textContent = money(value.total_price);
      $('[data-cart-status]').textContent = 'Miễn phí giao hàng tại Việt Nam.';
    };
    const setupNotice = (snapshot) => {
      if (!noticeForm || !noticePanel) return false;
      const button = $('[data-notice-submit]');
      const receipt = $('[data-notice-receipt]');
      const email = $('[data-notice-email]');
      const matches = savedNotice && savedNotice.submissionTime === snapshot.time;
      const returned = new URLSearchParams(location.search).get('payment_notice') === 'received';
      const accepted = returned && matches && savedNotice.status === 'pending' && $('[data-notice-server-state]').dataset.success === 'true' && !$('[data-notice-errors]');
      const completed = accepted || (matches && savedNotice.status === 'received');
      noticePanel.hidden = false;
      if (completed) {
        if (accepted) {
          savedNotice = {...savedNotice, status: 'received'};
          try { sessionStorage.setItem(noticeKey, JSON.stringify(savedNotice)); } catch (_) { /* still show the accepted result */ }
        }
        form.hidden = true;
        noticeForm.hidden = true;
        receipt.hidden = false;
        $('[data-notice-amount]').textContent = money(snapshot.cart.total_price);
        $('[data-notice-reference]').textContent = snapshot.phone;
        receipt.focus({preventScroll: true});
        receipt.scrollIntoView({block: 'start', behavior: 'auto'});
        return true;
      }
      email.value = snapshot.email || '';
      $('[data-notice-email-field]').hidden = !!email.value && email.checkValidity();
      $('[data-notice-name]').value = snapshot.name || 'Khách hàng FlashLabel';
      $('[data-notice-phone]').value = snapshot.phone;
      button.disabled = false;
      noticeForm.addEventListener('submit', (event) => {
        const errorBox = $('[data-notice-client-error]');
        errorBox.hidden = true;
        if (!email.checkValidity()) {
          event.preventDefault(); $('[data-notice-email-field]').hidden = false; email.reportValidity(); return;
        }
        try {
          const lines = snapshot.cart.items.map((item) => (item.product_title || item.title) + ' | ' + (item.variant_title || '') + ' | SKU: ' + (item.sku || '') + ' | Số lượng: ' + item.quantity + ' | ' + money(item.final_line_price));
          $('[data-notice-body]').value = ['FLASHLABEL — KHÁCH HÀNG BÁO ĐÃ CHUYỂN KHOẢN', 'Trạng thái: Khách hàng tự xác nhận; CHƯA xác minh tiền vào ngân hàng. Không tự động đánh dấu đã thanh toán.', 'Họ và tên: ' + $('[data-notice-name]').value, 'Email: ' + email.value, 'Số điện thoại / nội dung chuyển khoản: ' + snapshot.phone, 'Số tiền cần đối chiếu: ' + money(snapshot.cart.total_price), 'Tài khoản nhận: BIDV 8630000081', '', 'SẢN PHẨM', ...lines, '', 'Lần gửi thông tin nhận hàng: ' + new Date(snapshot.time).toISOString(), 'Thời gian thông báo: ' + new Date().toISOString()].join('\n');
          sessionStorage.setItem(noticeKey, JSON.stringify({submissionTime: snapshot.time, status: 'pending', time: Date.now()}));
          button.disabled = true;
          button.textContent = 'Đang gửi thông báo…';
        } catch (_) {
          event.preventDefault();
          errorBox.textContent = 'Chưa gửi được thông báo. Vui lòng tải lại trang hoặc liên hệ FlashLabel để xác nhận chuyển khoản.';
          errorBox.hidden = false;
        }
      });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        let record;
        try { record = JSON.parse(sessionStorage.getItem(noticeKey)); } catch (_) { /* optional */ }
        if (record && record.submissionTime === snapshot.time && record.status === 'received') { location.reload(); return; }
        button.disabled = false; button.textContent = 'Tôi đã chuyển khoản';
      });
      if (!payment) {
        form.hidden = true;
        noticePanel.scrollIntoView({block: 'start', behavior: 'auto'});
        return true;
      }
      return false;
    };
    if (payment || ($('[data-notice-errors]') && savedNotice && savedNotice.status === 'pending')) {
      let snapshot;
      try { snapshot = JSON.parse(sessionStorage.getItem(storageKey)); } catch (_) { /* storage unavailable */ }
      const recent = snapshot && Number.isFinite(snapshot.time) && Date.now() >= snapshot.time && Date.now() - snapshot.time < 2 * 60 * 60 * 1000;
      if (recent && /^(?:0\d{9}|\+?84\d{9})$/.test(snapshot.phone || '') && snapshot.cart && (payment || savedNotice.submissionTime === snapshot.time)) {
        try {
          validateCart(snapshot.cart);
          renderCart(snapshot.cart);
          if (setupNotice(snapshot)) return;
          $('[data-payment-amount]').textContent = money(snapshot.cart.total_price);
          $('[data-phone-reference]').textContent = snapshot.phone;
          payment.focus({preventScroll: true});
          payment.scrollIntoView({block: 'start', behavior: 'auto'});
          const copy = $('[data-copy-phone]');
          copy.hidden = false;
          copy.addEventListener('click', async () => {
            try { await navigator.clipboard.writeText(snapshot.phone); copy.textContent = 'Đã sao chép'; }
            catch (_) { copy.textContent = 'Vui lòng sao chép số trên'; }
          });
          const qr = $('[data-qr-image]');
          if (qr) {
            const image = qr.querySelector('img');
            const showQr = () => { if (image.naturalWidth) { qr.hidden = false; $('[data-payment-help]').textContent = 'Quét mã bằng ứng dụng ngân hàng. Nhập đúng số tiền và số điện thoại ở trên.'; } };
            image.addEventListener('load', showQr);
            image.addEventListener('error', () => { qr.hidden = true; $('[data-payment-help]').textContent = 'Không tải được mã QR. Vui lòng liên hệ FlashLabel trước khi chuyển tiền.'; });
            if (image.complete) showQr();
          }
        } catch (_) { snapshot = null; if (noticePanel) noticePanel.hidden = true; }
      } else {
        snapshot = null;
      }
      if (!snapshot || !recent) {
        $('[data-cart-status]').textContent = 'Vui lòng liên hệ FlashLabel để xác nhận thông tin.';
        const help = $('[data-payment-help]');
        if (help) help.textContent = 'Không tìm thấy số tiền và số điện thoại của lần gửi này. Vui lòng liên hệ FlashLabel trước khi thanh toán.';
      }
      return;
    }
    if (!form || !submit) return;
    loadCart().then((value) => {
      cart = value; renderCart(cart);
      submit.disabled = root.dataset.qrReady !== 'true';
    }).catch((error) => { $('[data-cart-status]').textContent = error.message; submit.disabled = true; });
    form.addEventListener('submit', async (event) => {
      if (prepared) { prepared = false; return; }
      event.preventDefault();
      const errorBox = $('[data-submit-error]'); errorBox.hidden = true;
      if (root.dataset.qrReady !== 'true') return;
      const phoneInput = form.querySelector('[name="contact[phone]"]');
      const phone = normalizePhone(phoneInput.value);
      if (!/^(?:0\d{9}|\+?84\d{9})$/.test(phone)) {
        phoneInput.setCustomValidity('Vui lòng nhập số điện thoại Việt Nam đầy đủ, bắt đầu bằng 0 hoặc +84.'); phoneInput.reportValidity(); return;
      }
      submit.disabled = true; submit.textContent = 'Đang gửi thông tin…';
      try {
        cart = await loadCart(); renderCart(cart);
        $('[data-contact-phone]').value = phone;
        $('[data-contact-total]').value = money(cart.total_price);
        const details = Array.from(new FormData(form).entries()).filter(([key]) => key.startsWith('contact[') && key !== 'contact[body]').map(([key, value]) => key.slice(8, -1) + ': ' + value);
        const lines = cart.items.map((item) => (item.product_title || item.title) + ' | ' + (item.variant_title || '') + ' | SKU: ' + (item.sku || '') + ' | Variant ID: ' + item.variant_id + ' | Số lượng: ' + item.quantity + ' | ' + money(item.final_line_price));
        const attribution = {};
        try {
          const saved = JSON.parse(sessionStorage.getItem('flashlabel-vn-qr-attribution-v1'));
          if (saved && Date.now() - saved.time < 2 * 60 * 60 * 1000) Object.assign(attribution, saved.values);
        } catch (_) { /* attribution is optional */ }
        for (const [key, value] of new URLSearchParams(location.search)) if (/^utm_(source|medium|campaign|content|term)$/.test(key)) attribution[key] = value.slice(0, 200);
        $('[data-contact-body]').value = ['FLASHLABEL — YÊU CẦU MUA HÀNG VIỆT NAM', ...details, '', 'SẢN PHẨM', ...lines, '', 'Giao hàng: Miễn phí tại Việt Nam', 'Tổng thanh toán: ' + money(cart.total_price), 'Nội dung chuyển khoản: ' + phone, 'Thanh toán: Chưa được xác nhận', 'Nguồn: ' + JSON.stringify(attribution), 'Thời gian: ' + new Date().toISOString()].join('\n');
        const name = form.querySelector('[name="contact[name]"]').value.trim();
        const email = form.querySelector('[name="contact[email]"]').value.trim();
        try { sessionStorage.setItem(storageKey, JSON.stringify({phone, name, email, cart, time: Date.now()})); }
        catch (_) { throw new Error('Trình duyệt không lưu được thông tin thanh toán. Vui lòng cho phép lưu trữ hoặc sử dụng trình duyệt khác.'); }
        prepared = true;
        form.requestSubmit();
      } catch (error) {
        prepared = false; errorBox.textContent = error.message || 'Chưa gửi được thông tin. Vui lòng thử lại.'; errorBox.hidden = false;
        submit.disabled = false; submit.textContent = 'Gửi thông tin & xem mã QR';
      }
    });
    form.querySelector('[name="contact[phone]"]').addEventListener('input', (event) => event.target.setCustomValidity(''));
    window.addEventListener('pageshow', (event) => { if (event.persisted) { submit.disabled = root.dataset.qrReady !== 'true'; submit.textContent = 'Gửi thông tin & xem mã QR'; } });
  };
  document.querySelectorAll('[data-flqr]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-flqr]').forEach(init));
})();
